module.exports = __webpack_public_path__ + "media/images/badge/tiratore-scelto_secondary-4e0b0844a760584f0959ed828914bb49.png";